const CUSTOMERS_TABLE_READY = "customers-table-ready"
const SEARCH_TEXT_STATE = "customers-table-search-text-state"
const ROWS_PER_PAGE_STATE = "customers-table-rows-per-page-state"
const PAGINATION_STATE = "customers-table-pagination-state"

const COMPANY_FILTER_STATE = "customers-table-company-filter-state"
const CUSTOMER_ID_FOR_ACTION = "customers-table-company-id-for-action"


const initialState = {
    isCustomersTableReady: true,
    customers: {},

    previousCompany: 0,

    customerSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case CUSTOMERS_TABLE_READY:
            return Object.assign({}, state, { isCustomersTableReady: action.payload })
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        
        case COMPANY_FILTER_STATE:
            return Object.assign({}, state, {previousCompany:action.payload})

        case CUSTOMER_ID_FOR_ACTION:
            return Object.assign({}, state, {customerSelectedId:action.payload})

        default:
        return state
    
    }

}

export function customerTableReady(data) {
    return {
        type: CUSTOMERS_TABLE_READY,
        payload: data
    }
}

export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function companyFilterState(company){
    return{
        type:COMPANY_FILTER_STATE,
        payload:company
    }
}

export function customerIdForAction(customerId){
    return{
        type:CUSTOMER_ID_FOR_ACTION,
        payload:customerId
    }
}


// WEBPACK FOOTER //
// ./src/modules/Customers/redux/customers.js